import React from 'react';
import {Title} from './ProjectPortfolioMonthByMonthTitle.styled';
import {useIntl} from 'react-intl';
import {getSingleNumberLabel} from '../ProjectPortfolioSingleNumberOptions';

export const ProjectPortfolioMonthByMonthTitle = ({selectedSingleValue}) => {
	const intl = useIntl();
	return <Title>{getSingleNumberLabel(selectedSingleValue, intl)}</Title>;
};
